var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5857 17.8579L35.5354 12.9081C36.5567 11.8859 37.7694 11.0749 39.1042 10.5215C40.4389 9.96804 41.8697 9.68301 43.3147 9.68268C44.7596 9.68234 46.1905 9.9667 47.5256 10.5195C48.8606 11.0723 50.0736 11.8828 51.0954 12.9045C52.1171 13.9263 52.9276 15.1393 53.4804 16.4743C54.0332 17.8094 54.3176 19.2403 54.3172 20.6852C54.3169 22.1302 54.0319 23.561 53.4784 24.8957C52.925 26.2305 52.114 27.4432 51.0918 28.4645L44.0207 35.5355C42.9993 36.557 41.7866 37.3672 40.452 37.92C39.1175 38.4728 37.6871 38.7574 36.2425 38.7574C34.798 38.7574 33.3676 38.4728 32.033 37.92C30.6984 37.3672 29.4858 36.557 28.4644 35.5355",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4142 46.1421L28.4644 51.0919C27.4431 52.1141 26.2305 52.9251 24.8957 53.4785C23.5609 54.0319 22.1301 54.317 20.6852 54.3173C19.2402 54.3176 17.8093 54.0333 16.4743 53.4805C15.1392 52.9277 13.9262 52.1172 12.9044 51.0955C11.8827 50.0737 11.0723 48.8607 10.5195 47.5256C9.96664 46.1906 9.68228 44.7597 9.68262 43.3147C9.68295 41.8698 9.96798 40.439 10.5214 39.1042C11.0748 37.7695 11.8858 36.5568 12.9081 35.5355L19.9791 28.4644C21.0006 27.443 22.2132 26.6327 23.5478 26.0799C24.8824 25.5271 26.3128 25.2426 27.7573 25.2426C29.2018 25.2426 30.6322 25.5271 31.9668 26.0799C33.3014 26.6327 34.514 27.443 35.5355 28.4644",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.5e1fdc9352db487001707b6273b02e8a.svg";
export { ForwardRef as ReactComponent };